import { ReactSVG } from 'react-svg';

import { TFunction } from '@mint-lib/i18n';
import styled from '@mint-lib/styled';

import type { SxProps } from '@myn/mui';
import { SVG } from '@myn/resources';

export const getIconFunc = (name: string) => {
  const iconPath =
    SVG.insightsPack.all[name as keyof typeof SVG.insightsPack.all] ||
    SVG.customPlatform;

  return styled(({ src = iconPath, ...props }: any) => (
    // @ts-ignore TODO: fix type
    <ReactSVG src={src} {...props} />
  ))`
    svg {
      width: 14px;
      height: 14px;
    }
  `;
};

export const getBudgetLabels = (t: TFunction) => {
  return {
    mediaBudget: t('Net media budget'),
    adserverCost: t('Adserver cost'),
    dspCost: t('DSP cost'),
    otherTechCost: t('Other tech costs'),
    total: t('total'),
  };
};

export const KpisLabels = {
  impression: 'Impressions',
  clicks: 'Clicks',
  videoViews: 'Complete views 100%',
  conversion: 'Conversions',
  leads: 'Leads',
  ctr: 'CTR',
  vtr: 'VTR',
  cr: 'CR',
};

export const TOTAL = 100;

export const unLlocatedData = {
  title: 'Unllocated',
  value: TOTAL,
  color: '#f0f0f0',
};

//Difference PopUp
export const PaperProps = {
  sx: {
    width: 282,
    borderRadius: 3,
    height: 92,
    overflowY: 'hidden',
  } as SxProps,
};

export const anchorOrigin = {
  vertical: 'top',
  horizontal: 'left',
} as const;

export const transformOrigin = {
  vertical: 80,
  horizontal: 100,
};

export type PopUpData = {
  comprasion: string;
  current?: string | null;
  previous?: string | null;
  difference?: number | null;
};
